import { configureStore } from '@reduxjs/toolkit'
import languageReducer from '../slice'

export const store = configureStore({
  reducer: {
    languageReducer,
  }
})